


import React, { useEffect, useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("dashboard");

  const fetchAgents = async () => {
    try {
      const res = await API.get("/agents/");
      console.log("AGENTS 👉", res.data);
      setAgents(res.data || []);
    } catch (err) {
      console.log("ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  const sendForm = async (id) => {
    try {
      await API.post(`/form/send/${id}`);
      alert("✅ Form Sent");
    } catch (err) {
      alert("❌ Failed to send");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_id");
    localStorage.removeItem("role");
    navigate("/");
  };

  const filteredAgents = showActiveOnly
    ? agents.filter((a) => a.is_active === true)
    : agents;

  const role = localStorage.getItem("role");

  return (
    <div className="dashboard-wrapper">
      <style>{`
        :root {
          --sidebar-width: 280px;
          --accent-gold: #fbbf24;
          --bg-dark: #11193a;
          --card-glass: rgba(228, 32, 32, 0.03);
          --border-glass: rgba(159, 174, 241, 0.08);
        }

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .dashboard-wrapper {
          display: flex;
          min-height: 100vh;
          background: var(--bg-dark);
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }

        /* --- SIDEBAR (FIXED & SCROLLABLE) --- */
        .sidebar {
          width: var(--sidebar-width);
          background: rgba(15, 23, 42, 0.95);
          backdrop-filter: blur(20px);
          border-right: 1px solid var(--border-glass);
          display: flex;
          flex-direction: column;
          position: fixed;
          top: 0; bottom: 0; left: 0;
          z-index: 100;
        }

        /* Header stays at top */
        .sidebar-header {
          padding: 30px 25px 20px;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .vgm-mini-logo {
          display: grid; grid-template-columns: repeat(2, 1fr); gap: 2px;
        }
        .vgm-mini-logo .dot {
          width: 8px; height: 8px; 
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
        }

        .sidebar h2.logo { font-size: 20px; font-weight: 800; letter-spacing: -1px; }

        /* Middle section scrolls if items are too many */
        .sidebar-nav-container {
          flex: 1;
          overflow-y: auto;
          padding: 10px 20px;
          scrollbar-width: thin;
          scrollbar-color: rgba(255,255,255,0.1) transparent;
        }

        .sidebar-nav-container::-webkit-scrollbar { width: 4px; }
        .sidebar-nav-container::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 10px; }

        .sidebar ul { list-style: none; }

        .sidebar li {
          padding: 14px 18px;
          margin-bottom: 6px;
          border-radius: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 14px;
          font-weight: 600;
          color: #94a3b8;
          transition: 0.2s ease;
        }

        .sidebar li:hover { background: rgba(255, 255, 255, 0.05); color: white; }
        .sidebar li.active { background: rgba(251, 191, 36, 0.1); color: var(--accent-gold); }

        /* Footer stays at bottom */
        .sidebar-footer {
          padding: 20px;
          border-top: 1px solid var(--border-glass);
        }

        .logout-btn {
          width: 100%;
          background: rgba(235, 127, 127, 0.1);
          color: #dd6060;
          border: 1px solid rgba(239, 68, 68, 0.2);
          padding: 12px;
          border-radius: 12px;
          font-weight: 700;
          cursor: pointer;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          transition: 0.3s;
        }
        .logout-btn:hover { background: #ef4444; color: white; }

        /* --- MAIN CONTENT --- */
        .main-content {
          margin-left: var(--sidebar-width);
          flex: 1;
          padding: 40px;
          width: 100%;
          transition: margin 0.3s ease;
        }

        .header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
          margin-bottom: 30px;
        }

        .title { font-size: 28px; font-weight: 800; letter-spacing: -1px; }

        .filter-bar {
          background: var(--card-glass);
          padding: 5px;
          border-radius: 12px;
          display: inline-flex;
          border: 1px solid var(--border-glass);
        }

        .filter-btn {
          padding: 8px 18px;
          border-radius: 8px;
          border: none;
          background: transparent;
          color: #1b6de0;
          font-weight: 700;
          cursor: pointer;
          transition: 0.3s;
          font-size: 13px;
        }

        .filter-btn.active { background: var(--accent-gold); color: var(--bg-dark); }

        /* --- TABLE --- */
        .table-responsive {
          width: 100%;
          overflow-x: auto;
          background: var(--card-glass);
          border: 1px solid var(--border-glass);
          border-radius: 20px;
          backdrop-filter: blur(10px);
        }

        table { width: 100%; border-collapse: collapse; min-width: 900px; }
        th { padding: 18px 24px; text-align: left; font-size: 11px; color: #64748b; text-transform: uppercase; letter-spacing: 1px; border-bottom: 1px solid var(--border-glass); }
        td { padding: 18px 24px; font-size: 14px; border-bottom: 1px solid var(--border-glass); vertical-align: middle; }

        .status { padding: 5px 12px; border-radius: 20px; font-size: 11px; font-weight: 700; text-transform: uppercase; }
        .status.approved, .status.bhr_approved { background: rgba(34, 197, 94, 0.1); color: #22c55e; }
        .status.pending { background: rgba(251, 191, 36, 0.1); color: #fbbf24; }

        .btn-send {
          padding: 8px 16px;
          border-radius: 8px;
          border: 1px solid var(--accent-gold);
          background: transparent;
          color: var(--accent-gold);
          font-weight: 700;
          font-size: 12px;
          cursor: pointer;
          transition: 0.3s;
        }

        .btn-send:hover:not(:disabled) { background: var(--accent-gold); color: var(--bg-dark); }

        // /* --- RESPONSIVE BREAKPOINTS --- */
        // @media (max-width: 1024px) {
        //   --sidebar-width: 250px;
        // }

        // @media (max-width: 768px) {
        //   .dashboard-wrapper { flex-direction: column; }
        //   .sidebar { 
        //     position: relative; width: 100%; height: auto; border-right: none; border-bottom: 1px solid var(--border-glass); 
        //   }
        //   .sidebar-nav-container { overflow-y: visible; max-height: 300px; }
        //   .main-content { margin-left: 0; padding: 20px; }
        //   .header-row { flex-direction: column; align-items: flex-start; }
        // }


        /* --- RESPONSIVE BREAKPOINTS --- */

/* Tablet */
@media (max-width: 1024px) {
  :root {
    --sidebar-width: 240px;
  }

  .main-content {
    padding: 25px;
  }

  .title {
    font-size: 22px;
  }
}

/* Mobile */
@media (max-width: 768px) {

  .dashboard-wrapper {
    flex-direction: column;
  }

  /* Sidebar becomes top navbar */
  .sidebar {
    position: relative;
    width: 100%;
    height: auto;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
  }

  .sidebar-header {
    padding: 0;
  }

  .sidebar-nav-container {
    display: flex;
    overflow-x: auto;
    padding: 10px 0;
  }

  .sidebar ul {
    display: flex;
    gap: 10px;
  }

  .sidebar li {
    white-space: nowrap;
    padding: 10px 12px;
    font-size: 12px;
  }

  .sidebar-footer {
    display: none;
  }

  .main-content {
    margin-left: 0;
    padding: 15px;
  }

  .header-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-bar {
    width: 100%;
    justify-content: space-between;
  }

  .filter-btn {
    flex: 1;
    font-size: 12px;
  }

  /* Table scroll fix */
  .table-responsive {
    overflow-x: auto;
  }

  table {
    min-width: 700px;
  }
}

/* Extra small devices */
@media (max-width: 480px) {

  .title {
    font-size: 18px;
  }

  .filter-btn {
    padding: 6px;
    font-size: 11px;
  }

  td, th {
    padding: 10px;
    font-size: 12px;
  }

  .btn-send {
    padding: 6px 10px;
    font-size: 11px;
  }
}
      `}</style>

      {/* 🔹 Sidebar Navigation */}
      <nav className="sidebar">
        <div className="sidebar-header">
          <div className="vgm-mini-logo">
            
          </div>
          <h1 className="logo">CALM</h1>
        </div>

        {/* Scrollable middle section */}
        <div className="sidebar-nav-container">
          <ul>
            <li className={activeMenu === "dashboard" ? "active" : ""} onClick={() => setActiveMenu("dashboard")}>
              <span>📊</span> Dashboard
            </li>
            <li onClick={() => navigate("/upload")}><span>📤</span> Upload Agent</li>
            <li onClick={() => navigate("/edit-list")}><span>✏️</span> Edit Agent</li>
            <li onClick={() => navigate("/send-form")}><span>📧</span> Send CA Forms</li>
            <li onClick={() => navigate("/manage-agents")}><span>⚡</span> Manage Status</li>
            <li onClick={() => navigate("/download-excel")}><span>📥</span> Export Excel</li>
            <li onClick={() => navigate("/submitted")}><span>📁</span> Submissions</li>
            <li onClick={() => navigate("/rejected-agents")}><span>📄</span> ❌ View Rejected Agents</li>

            <li onClick={() => navigate("/logs")}><span>📄</span> Activity Logs</li>
            

            {/* Role-based logic kept intact */}
            {role === "admin" && (
              <li onClick={() => navigate("/admin-approval")}><span>🛡️</span> Admin Approval</li>
            )}

            {role === "bhr" && (
              <li style={{ color: "#475569", cursor: "not-allowed", opacity: 0.6 }}>
                <span>🔒</span> Admin Approval (Restricted)
              </li>

              
            )}

            <li onClick={() => navigate("/summary")}><span>📊</span> Summary</li>
          </ul>
        </div>

        {/* Bottom pinned Logout */}
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <span>🚪</span> Logout
          </button>
        </div>
      </nav>

      {/* 🔹 Main Dashboard Content */}
      <main className="main-content">
        <header className="header-row">
          <h1 className="title">CALM Deck</h1>
          <div className="filter-bar">
            <button
              className={`filter-btn ${showActiveOnly ? "active" : ""}`}
              onClick={() => setShowActiveOnly(true)}
            >
              🟢 Active Agents
            </button>
            <button
              className={`filter-btn ${!showActiveOnly ? "active" : ""}`}
              onClick={() => setShowActiveOnly(false)}
            >
              📋 All Agents
            </button>
          </div>
        </header>

        {loading ? (
          <div style={{ textAlign: "center", padding: "50px" }}>
            <p style={{ color: "#94a3b8" }}>🔄 Synchronizing secure records...</p>
          </div>
        ) : filteredAgents.length === 0 ? (
          <div style={{ textAlign: "center", padding: "50px", background: 'var(--card-glass)', borderRadius: '20px' }}>
            <p>No agent records found for this view.</p>
          </div>
        ) : activeMenu === "dashboard" ? (
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Agent Name</th>
                  <th>Email Identity</th>
                  <th>Contact No.</th>
                  <th>Current Status</th>
                  <th>Operations</th>
                </tr>
              </thead>
              <tbody>
                {filteredAgents.map((a) => (
                  <tr key={a.id}>
                    <td><strong style={{ color: "#f8fafc" }}>{a.name_as_per_pan || "-"}</strong></td>
                    <td style={{ color: "#94a3b8" }}>{a.mail_id || "-"}</td>
                    <td>{a.mobile_no || "-"}</td>
                    <td>
                      <span className={`status ${a.status || "pending"}`}>
                        {a.status || "pending"}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-send"
                        onClick={() => sendForm(a.id)}
                        disabled={
                          a.is_signed === true ||
                          a.status === "bhr_approved" ||
                          a.status === "approved"
                        }
                        style={{
                          opacity: (a.is_signed || a.status === "bhr_approved" || a.status === "approved") ? 0.5 : 1,
                          cursor: (a.is_signed || a.status === "bhr_approved" || a.status === "approved") ? "not-allowed" : "pointer",
                        }}
                      >
                        {a.is_signed ? "✔ Signed" : 
                         a.status === "bhr_approved" ? "✔ BHR Approved" : 
                         a.status === "approved" ? "✔ Final Approved" : 
                         "✉ Send Form"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "100px", opacity: 0.5 }}>
            <h2>{activeMenu.toUpperCase()}</h2>
            <p>Module is loading from secure server...</p>
          </div>
        )}
      </main>
    </div>
  );
}

export default Dashboard;